// extracted by mini-css-extract-plugin
module.exports = {"markdown":"MarkdownStyles_markdown__XlZyt"};